import { apiSlice } from './apiSlice'

export interface Notification {
  id?: string
  user_id: string
  title: string
  message: string
  type: 'info' | 'warning' | 'success' | 'error'
  read: boolean
  created_at?: string
  read_at?: string
  metadata?: Record<string, any>
}

export interface NotificationCreate {
  user_id: string
  title: string
  message: string
  type?: 'info' | 'warning' | 'success' | 'error'
  metadata?: Record<string, any>
}

export interface UnreadCount {
  count: number
}

export const notificationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<Notification[], { unread_only?: boolean; limit?: number }>({
      query: (params) => ({
        url: '/notifications',
        params,
      }),
      providesTags: ['Notification'],
    }),
    getUnreadCount: builder.query<UnreadCount, void>({
      query: () => '/notifications/unread-count',
      providesTags: ['Notification'],
    }),
    markAsRead: builder.mutation<{ success: boolean; message: string }, string>({
      query: (notificationId) => ({
        url: `/notifications/mark-read/${notificationId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Notification'],
    }),
    markAllAsRead: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({
        url: '/notifications/mark-all-read',
        method: 'POST',
      }),
      invalidatesTags: ['Notification'],
    }),
    deleteNotification: builder.mutation<{ success: boolean; message: string }, string>({
      query: (notificationId) => ({
        url: `/notifications/${notificationId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notification'],
    }),
  }),
})

export const {
  useGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
} = notificationsApi

